<template>
  <div>
    <h1
      class="title has-text-grey-dark is-size-4"
      :class="{ 'margin-bottom-1': !skipMarginBottom }"
    >
      <slot></slot>
    </h1>
  </div>
</template>

<script>
export default {
  props: { skipMarginBottom: Boolean }
};
</script>
